import axiosInstance from "../axiosClient";

export const getUserProfile = async (token) => {
    try {

        const response = await axiosInstance.get(
            `/user/profile`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};


export const updateUserProfile = async (token, userId, telephoneNumber, faaIdValue, marketingEmails, notificationEmails) => {
    try {

        return await axiosInstance.put(
            `/user/profile/${userId}`, {telephoneNumber: telephoneNumber, faaIdValue: faaIdValue, marketingEmails: marketingEmails, notificationEmails: notificationEmails},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
    } catch (error) {
        throw error;
    }
};

export const getUserContext = async (token) => {
    try {
        const response = await axiosInstance.get(
            `/user/context`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};